import Vue from 'vue';

// 拖拽改变容器宽度
Vue.directive('resizable', {
  bind(el, binding, vnode) {
    const minWidth = binding.value.minWidth || 0;
    const maxWidth = (window.innerWidth / 3);

    let isResizing = false;
    let startX, startWidth;

    el.style.position = 'relative';
    // 拖拽bar
    let handle = el.querySelector('.handleBar');
    if (!handle) {
      handle = document.createElement('div');
      handle.classList.add('handleBar');
      handle.style.cursor = 'col-resize';
      handle.style.width = '8px';
      handle.style.height = '100%';
      handle.style.position = 'absolute';
      handle.style.right = 0;
      handle.style.top = 0;
      handle.style['border-right'] = '1px solid transparent';
      el.appendChild(handle);
    }
    handle.addEventListener('mousedown', function(e) {
      e.preventDefault();
      isResizing = true;
      handle.style['border-right-color'] = '#ddd';
      startX = e.pageX;
      startWidth = parseInt(window.getComputedStyle(el).width, 10);
      document.addEventListener('mousemove', resizing);
      document.addEventListener('mouseup', stopResize);
    });

    function resizing(e) {
      e.preventDefault();
      if (!isResizing) return;
      el.style.cursor = 'col-resize';
      const offset = e.pageX - startX;
      const nowWidth = startWidth + offset;
      if (nowWidth >= minWidth && nowWidth <= maxWidth) {
        el.style.width = startWidth + offset + 'px';
      }
    }

    function stopResize() {
      isResizing = false;
      el.style.cursor = 'default';
      handle.style['border-right-color'] = 'transparent';
      document.removeEventListener('mousemove', resizing);
      document.removeEventListener('mouseup', stopResize);
    }
  }
})


// WEBPACK FOOTER //
// ./src/directives/index.js